module.exports = __webpack_public_path__ + "img/chr_ts_17_penlight.910a87cd.png";